import { SVGProps, Ref, forwardRef } from 'react'
const SvgApple = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.008 21.96c-1.16 1.124-2.438.949-3.656.419-1.296-.541-2.48-.575-3.848 0-1.704.735-2.608.521-3.634-.42C1.076 15.996 1.932 6.91 8.516 6.569c1.597.085 2.715.883 3.655.949 1.399-.285 2.737-1.099 4.233-.992 1.798.145 3.143.855 4.04 2.131-3.698 2.223-2.821 7.098.576 8.466-.68 1.785-1.552 3.549-3.015 4.853l.003-.015ZM12.043 6.504c-.173-2.651 1.976-4.832 4.447-5.046.34 3.057-2.78 5.345-4.447 5.046Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgApple)
export default ForwardRef
